import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Select from "react-select";
import * as Yup from "yup";
import { toast } from "react-toastify";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import trash from "../../../assets/misc/trash.png";
import { DurationType, colourStylesFullWidth } from "../../../data/Constants";
import PlainButton from "../../../components/buttons/PlainButton";
import { TechnologyFieldsOptions } from "../../../data/UserInfoStepperConstants";
import Pathpin from "../../../assets/misc/pdfimg.png";
import { TypeOfCPDActivities } from "../../../data/cpdConstants";
import { TypeOfCPDTaregetAudience } from "../../../data/targetaudienceconstant";
import { atpService } from "../../../services/atpService";
import FilePreview from "../../../components/FilePreview";
import InfoIcon from "../../../assets/misc/informtion.svg";
import AttachmentInfo from "../cpdActivitiesUser/partials/AttachmentInfo";
import { useSelector } from "react-redux";
import moment from "moment";

const CreateCPDActivitiesForm = ({ closeModal, disabled, initialValues, refreshTableData, techFieldAdd, setTechFieldShow, isView }) => {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [fileError, setFileError] = useState("");
    const [isFileChanges, setIsFileChanges] = useState(false);
    const [deletedAttachments, setDeletedAttachment] = useState([]);
    const [selectedDocumentType, setSelectedDocumentType] = useState(null);
    const userType = 3;
    const [showAttachmentInfoPopup, setAttachmentInfoPopup] = useState(false);
    const registrationDate = useSelector((state) => state?.atp?.dashboard?.createdDate);
    const fileInputRef = useRef(null);
    // Function to check if "Related to All Fields" option is already present
    const isRelatedToAllFieldsPresent = () => {
        return TechnologyFieldsOptions.some((option) => option.value === 25);
    };
    const compulsoryDocumentTypes = ["copy_of_programme_kit", "sample_of_poster", "sample_of_certificate", "trainer_profile"];
    const documentOptions = [
        {
            value: "copy_of_programme_kit",
            label: (
                <span>
                    A copy of the programme kit including detail of programme outline (modules/ tentative/ agenda or etc.). <span style={{ color: "red" }}>*</span>
                </span>
            ),
        },
        {
            value: "sample_of_poster",
            label: (
                <span>
                    A sample of poster, brochures, or flyers (promotional purpose). <span style={{ color: "red" }}>*</span>
                </span>
            ),
        },
        {
            value: "sample_of_certificate",
            label: (
                <span>
                    A sample of certificate (certification after completion of the programme or after the test). <span style={{ color: "red" }}>*</span>
                </span>
            ),
        },
        {
            value: "trainer_profile",
            label: (
                <span>
                    Speaker or trainer profiles for each related course. <span style={{ color: "red" }}>*</span>
                </span>
            ),
        },
        { value: "documentary_evidence", label: "Documentary evidence from certification body (for professional certification course only)" },
        { value: "other_relevant_documentation", label: "Any other relevant documentation deemed supportive of the application." },
    ];

    if (userType === 3 && !isRelatedToAllFieldsPresent()) {
        // Add the "Related to All Fields" option
        TechnologyFieldsOptions.push({
            label: "Related to All Fields",
            value: 25,
        });
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const validationSchema = (initialValues) => {
        return Yup.object().shape({
            title: Yup.string().trim().required("Title is required"),
            location: Yup.string().trim().required("Location is required"),
            duration_time: Yup.number().required("Duration time is required").min(1, "Duration time must greater than 0"),
            // date_time: Yup.string().required("Date and time is required"),
            start_date_time: Yup.string().required("Date and time is required"),
            end_date_time: Yup.string()
                .required("End date and time is required")
                .test("is-greater", "End date and time must be later than start date and time", function (value) {
                    const { start_date_time } = this.parent;
                    return new Date(value) > new Date(start_date_time);
                }),
            duration_type: Yup.number().required("Duration type is required"),
            // tech_field: Yup.string().required("Technology field is required"),
            tech_field: Yup.array().of(Yup.string()).required("Technology field is required"),
            target_audience: Yup.string().required("Target Audience is required"),
            type_of_cpd: Yup.string().required("Type of CPD Activity is required"),
            // web_url: Yup.string().test("validUrl", "Invalid URL", function (value) {
            //     if (value && value.length > 0) {
            //         return /^https?:\/\//.test(value);
            //     }
            //     return true; // If the value is empty, consider it valid
            // }),
            description: Yup.string().min(10, "Description must be at least 10 characters").max(200, "Description must be less than 200 characters").required("Description is required"),
            organization: Yup.string().required("Organisation is required"),
        });
    };

    const handleDocumentTypeChange = (option) => {
        setSelectedDocumentType(option?.value);
        document.getElementById("attachment").click();
    };
    const areAllFilesEmpty = selectedFiles.every((fileObj) => !fileObj.file);

    // handles submission
    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        const missingCompulsoryFiles = compulsoryDocumentTypes.filter((type) => selectedFiles.every((fileObj) => fileObj.type !== type || !fileObj.file));

        if (missingCompulsoryFiles.length > 0) {
            setFileError("Please upload all compulsory documents.");
            return;
        } else if (selectedFiles.length > 10) {
            setFileError("At most 10 files can be required.");
            return;
        } else {
            setFileError("");
        }
        try {
            setSubmitting(true);
            const formData = new FormData();
            formData.append("title", values.title);
            formData.append("location", values.location);
            formData.append("duration_time", values.duration_time);
            formData.append("duration_type", values.duration_type);
            formData.append("start_date_time", new Date(values.start_date_time).toISOString());
            formData.append("end_date_time", new Date(values.end_date_time).toISOString());
            // formData.append("tech_field", JSON.stringify(values.tech_field));
            // Convert tech_field to an array of integers and append to formData
            if (values.tech_field && values.tech_field.length > 0) {
                const techFieldIntegers = values.tech_field.map(Number);
                formData.append("tech_field", JSON.stringify(techFieldIntegers));
            }
            selectedFiles.forEach((item) => {
                if (item.file) {
                    // Check if the file exists before appending
                    formData.append(item.type, item.file);
                }
            });
            formData.append("organization", values?.organization || "");
            formData.append("type_of_cpd", values.type_of_cpd);
            formData.append("target_audience", values.target_audience);
            // formData.append("web_url", values.web_url);
            formData.append("description", values.description);
            formData.append("deleted_attachments", JSON.stringify(deletedAttachments));
            let response;
            if (values?.id) {
                response = await atpService.updateCPD(values?.id, formData);
            } else {
                response = await atpService.createActivity(formData);
            }
            toast.success("Your program has been successfully registered and is under review.");

            closeModal();
            resetForm();
            refreshTableData();
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setSubmitting(false);
        }
    };
    useEffect(() => {
        if (initialValues) {
            // Set initial files based on initialValues keys
            setSelectedFiles([
                { type: "copy_of_programme_kit", file: initialValues.copy_of_programme_kit },
                { type: "sample_of_poster", file: initialValues.sample_of_poster },
                { type: "sample_of_certificate", file: initialValues.sample_of_certificate },
                { type: "documentary_evidence", file: initialValues.documentary_evidence },
                { type: "trainer_profile", file: initialValues.trainer_profile },
                { type: "other_relevant_documentation", file: initialValues.other_relevant_documentation },
                // { type: "letter_of_appointment", file: initialValues.letter_of_appointment },
            ]);
        }
    }, [initialValues]); // Re-run when initialValues changes

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        if (files.length > 0) {
            const newFiles = files.filter((file) => file.type === "application/pdf");
            if (newFiles.length !== files.length) {
                setFileError("Only PDF files are allowed.");
                return;
            }
            setFileError("");

            setSelectedFiles((prevFiles) => {
                // Update or add the new file with the selected document type
                const updatedFiles = prevFiles.map((fileObj) => (fileObj.type === selectedDocumentType ? { type: selectedDocumentType, file: newFiles[0], name: newFiles[0].name } : fileObj));

                // If no file was replaced, add the new file
                if (!updatedFiles.some((fileObj) => fileObj.type === selectedDocumentType)) {
                    updatedFiles.push({ type: selectedDocumentType, file: newFiles[0], name: newFiles[0].name });
                }

                return updatedFiles;
            });

            // Reset the file input value to allow re-uploading the same file
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        }
    };

    const removeFile = (indexToRemove) => {
        const updatedFiles = selectedFiles.filter((_, index) => index !== indexToRemove);
        setSelectedFiles(updatedFiles);
        setDeletedAttachment((prev) => [...prev, indexToRemove]);
    };

    const handleAttachementInfo = () => {
        setAttachmentInfoPopup(true);
    };
    const closeAttachmentInfo = () => {
        setAttachmentInfoPopup(false);
    };

    return (
        <>
            {showAttachmentInfoPopup && <AttachmentInfo onClose={closeAttachmentInfo} />}
            <Formik initialValues={initialValues} validationSchema={validationSchema(initialValues)} onSubmit={handleSubmit} enableReinitialize={true}>
                {({ setFieldValue, isSubmitting, values }) => {
                    return (
                        <Form className="stepper-form-container astriknotshow">
                            <div className="row mb-5">
                                <div className="col-lg-6 col-12">
                                    <label className="mb-1">Title</label>
                                    <Field type="text" name="title" className="form-control mb-2" autoComplete="off" placeholder="Advanced Diploma in IT" disabled={disabled || isView} />
                                    <ErrorMessage name="title" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                </div>
                                <div className="col-lg-6  col-12">
                                    <label className="mb-1">Location/Platform</label>
                                    <Field type="text" name="location" className="form-control mb-2" autoComplete="off" placeholder="Eg:MBOT/Micrsoft Teams" disabled={disabled || isView} />
                                    <ErrorMessage name="location" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                </div>
                            </div>
                            <div className="row mb-5">
                                <div className="col-lg-6 col-12">
                                    <label className="mb-1">Start Date & Time</label>
                                    <DatePicker
                                        format="DD/MM/YYYY HH:mm A"
                                        plugins={[<TimePicker position="bottom" />]}
                                        editable={false}
                                        name="start_date_time"
                                        value={values?.start_date_time}
                                        disabled={disabled || isView}
                                        type="text"
                                        minDate={moment(registrationDate).set({ hours: 0, minutes: 0, seconds: 0 }).toDate()}
                                        maxDate={values?.end_date_time}
                                        autoComplete="off"
                                        months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
                                        onChange={(date) => {
                                            const formattedDate = new Date(date).toISOString();
                                            setFieldValue("start_date_time", formattedDate);

                                            if (values?.end_date_time && values.duration_type === 2) {
                                                // Only calculate for days
                                                const startDate = new Date(formattedDate);
                                                const endDate = new Date(values.end_date_time);

                                                // Get only the date parts, ignoring the time
                                                const startDay = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
                                                const endDay = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

                                                // Check if dates are different
                                                const durationDays = (endDay - startDay) / (1000 * 60 * 60 * 24); // Difference in days

                                                if (durationDays >= 0) {
                                                    // Add 1 to always count the end date as a full day, regardless of time
                                                    setFieldValue("duration_time", Math.ceil(durationDays) + 1);
                                                }
                                            }
                                        }}
                                    />
                                    <ErrorMessage name="start_date_time" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                </div>
                                <div className="col-lg-6  col-12">
                                    <label className="mb-1">End Date & Time</label>
                                    <DatePicker
                                        format="DD/MM/YYYY HH:mm A"
                                        plugins={[<TimePicker position="bottom" />]}
                                        editable={false}
                                        name="end_date_time"
                                        value={values?.end_date_time}
                                        disabled={disabled || isView}
                                        type="text"
                                        months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
                                        minDate={values?.start_date_time ? values.start_date_time : registrationDate}
                                        autoComplete="off"
                                        onChange={(date) => {
                                            const formattedDate = new Date(date).toISOString();
                                            setFieldValue("end_date_time", formattedDate);

                                            if (values?.start_date_time && values.duration_type === 2) {
                                                // Only calculate for days
                                                const startDate = new Date(values.start_date_time);
                                                const endDate = new Date(formattedDate);

                                                // Get only the date parts, ignoring the time
                                                const startDay = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
                                                const endDay = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

                                                // Check if dates are different
                                                const durationDays = (endDay - startDay) / (1000 * 60 * 60 * 24); // Difference in days

                                                if (durationDays >= 0) {
                                                    // Add 1 to always count the end date as a full day, regardless of time
                                                    setFieldValue("duration_time", Math.ceil(durationDays) + 1);
                                                }
                                            }
                                        }}
                                    />
                                    <ErrorMessage name="end_date_time" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                </div>
                            </div>
                            <div className="row mb-5">
                                <div className="col-lg-6 col-12">
                                    <label className="mb-1">Duration</label>
                                    <div className="d-flex gap-2">
                                        <div className="col-lg-8  col-12">
                                            {" "}
                                            <Field
                                                type="number"
                                                name="duration_time"
                                                className="form-control mr-2"
                                                disabled={disabled || isView}
                                                placeholder={values?.duration_type === 1 ? "Enter hours" : ""}
                                                readOnly={values?.duration_type === 2}
                                            />
                                        </div>
                                        <Select
                                            options={[
                                                { label: "Days", value: 2 },
                                                { label: "Hours", value: 1 },
                                            ]}
                                            isSearchable={false}
                                            styles={colourStylesFullWidth}
                                            placeholder="Select"
                                            components={{ IndicatorSeparator: () => null }}
                                            value={DurationType.find((option) => option.value === values?.duration_type)}
                                            onChange={(option) => {
                                                setFieldValue("duration_type", option.value);
                                                if (option.value === 1) {
                                                    setFieldValue("duration_time", ""); // Clear duration time for manual input in hours
                                                } else if (option.value === 2 && values?.start_date_time && values?.end_date_time) {
                                                    // Recalculate duration if days are selected
                                                    const startDate = new Date(values.start_date_time);
                                                    const endDate = new Date(values.end_date_time);
                                                    const startDay = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
                                                    const endDay = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

                                                    const durationDays = (endDay - startDay) / (1000 * 60 * 60 * 24);
                                                    setFieldValue("duration_time", Math.ceil(durationDays) + 1);
                                                }
                                            }}
                                            isDisabled={isView || initialValues?.isSave == "1"}
                                            selectedValue={{ label: "Days", value: 2 }} // Set "Days" as default
                                        />
                                    </div>
                                    <ErrorMessage name="duration_time" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                    <ErrorMessage name="duration_type" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                </div>
                                <div className="col-lg-6  col-12">
                                    <label className="mb-1">Organization</label>
                                    <Field type="text" name="organization" className="form-control mb-2" autoComplete="off" placeholder="Organization name" disabled={disabled || isView} />
                                    <ErrorMessage name="organization" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                </div>
                            </div>

                            <div className="row mb-5">
                                <div className="col-lg-6 col-12">
                                    <label className="mb-1">Technology Field</label>
                                    <Select
                                        isMulti
                                        options={TechnologyFieldsOptions}
                                        isSearchable={false}
                                        styles={colourStylesFullWidth}
                                        name="tech_field"
                                        components={{
                                            IndicatorSeparator: () => null,
                                        }}
                                        onChange={(valueObj) => {
                                            setTechFieldShow(false);
                                            setFieldValue("tech_field", valueObj ? valueObj.map((option) => option?.value) : []);
                                        }}
                                        value={TechnologyFieldsOptions.filter((option) => values?.tech_field?.includes(techFieldAdd ? String(option?.value) : option?.value))}
                                        isDisabled={disabled || isView}
                                    />
                                    <ErrorMessage name="tech_field" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                </div>
                                {/* <>
                                <div className="col-lg-6 col-12">
                                    <label className="mb-1">Attachment</label>
                                    <img className="pdf-fileinput uplodfile_pdf_icn" src={Pathpin} alt="" />
                                    <input
                                        id="attachment"
                                        multiple
                                        key={selectedFiles}
                                        name="attachment"
                                        type="file"
                                        accept="application/pdf"
                                        className="fileUpload"
                                        onChange={(event) => {
                                            handleFileChange(event);
                                            setFieldValue("attachment", selectedFiles);
                                        }}
                                        style={{ position: "relative" }}
                                    />
                                    <ErrorMessage name="attachment" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                    {fileError && <div className="text-danger fs-14 fw-400 mt-1">{fileError}</div>}
                                </div>
                                <div className="row mt-3 ">
                                    {selectedFiles?.map((file, index) => (
                                        <div key={index} className="col-6 position-relative mt-3">
                                            <div className="form-control d-flex justify-content-between align-items-center">
                                                <div className="center-alignment">
                                                    <div>
                                                        <img className="" width={26} src={Pathpin} alt="PDF" />
                                                    </div>
                                                    <div className="ms-3">File.pdf</div>
                                                </div>
                                                <img src={trash} alt="Delete" className="cursor-pointer delete_icn" width={25} height={25} onClick={() => removeFile(file.index)} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </> */}
                                <div className="col-lg-6 col-12">
                                    <label className="mb-1">
                                        Attachment
                                        <img src={InfoIcon} className="img-fluid cursor-pointer ms-2" style={{ height: "20px", width: "20px" }} alt="info" onClick={handleAttachementInfo} />
                                    </label>
                                    <Select
                                        options={documentOptions}
                                        onChange={handleDocumentTypeChange}
                                        styles={colourStylesFullWidth}
                                        value={documentOptions.find((option) => option.value === selectedDocumentType)}
                                        placeholder="Select document type..."
                                        isDisabled={disabled || isView}
                                        isSearchable={false}
                                    />
                                    <input
                                        id="attachment"
                                        multiple
                                        name="files"
                                        type="file"
                                        ref={fileInputRef} // Attach the ref to the input
                                        accept="application/pdf"
                                        className="fileUpload"
                                        onChange={(event) => {
                                            handleFileChange(event);
                                            setFieldValue("files", selectedFiles);
                                        }}
                                        isDisabled={disabled}
                                        style={{ position: "absolute", opacity: 0, height: 0, width: 0 }}
                                    />
                                    <ErrorMessage name="files" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                    {fileError && <div className="text-danger fs-14 fw-400 mt-1">{fileError}</div>}
                                </div>

                                {areAllFilesEmpty ? (
                                    <p></p> // Display "None" if all files are empty
                                ) : (
                                    <div className="row mt-3">
                                        {selectedFiles.map((file, index) => {
                                            if (!file.file) return null; // Skip rendering if no file exists
                                            return (
                                                <div key={index} className="col-6 position-relative mt-3">
                                                    <div className="form-control d-flex justify-content-between align-items-center">
                                                        <div className="center-alignment">
                                                            {/* Use FilePreview component to display file preview */}
                                                            <FilePreview
                                                                showViewIcon={1}
                                                                showTrashIcon={0}
                                                                pathValue={0}
                                                                pathNameLabel={file.file || `path_${index}`}
                                                                fileNameLabel={file.type || `Attachment ${index + 1}`}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                            <div className="row mb-5">
                                <div className="col-lg-6 col-12">
                                    <label className="mb-1">Target group/ Audiences</label>
                                    <Select
                                        options={TypeOfCPDTaregetAudience}
                                        isSearchable={false}
                                        styles={colourStylesFullWidth}
                                        components={{
                                            IndicatorSeparator: () => null,
                                        }}
                                        onChange={(valueObj) => setFieldValue("target_audience", valueObj?.value)}
                                        value={TypeOfCPDTaregetAudience.find((option) => option.value === values?.target_audience)}
                                        isDisabled={disabled || isView}
                                    />
                                    <ErrorMessage name="target_audience" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                </div>
                                <div className="col-lg-6 col-12">
                                    <label className="mb-1">Type of CPD Activity</label>
                                    <Select
                                        options={TypeOfCPDActivities}
                                        isSearchable={false}
                                        styles={colourStylesFullWidth}
                                        components={{
                                            IndicatorSeparator: () => null,
                                        }}
                                        onChange={(valueObj) => setFieldValue("type_of_cpd", valueObj?.value)}
                                        value={TypeOfCPDActivities.find((option) => option.value === values?.type_of_cpd)}
                                        isDisabled={disabled || isView}
                                    />
                                    <ErrorMessage name="type_of_cpd" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                </div>
                            </div>
                            {/* <div className="row mb-5">
                            <div className="col-lg-12 col-12">
                                <label className="mb-1">Registration Programme Link</label>
                                <Field type="text" name="web_url" className="form-control mb-2" autoComplete="off" placeholder="Advanced Diploma in IT" disabled={disabled || isView} />
                                <ErrorMessage name="web_url" component="div" className="text-danger fs-14 fw-400 mt-1" />
                            </div>
                        </div> */}
                            <div className="row mb-5">
                                <div className="col-lg-12 col-12">
                                    <label className="mb-1">Description </label>
                                    <Field
                                        as="textarea"
                                        name="description"
                                        className="form-control mb-2"
                                        autoComplete="off"
                                        placeholder="Details of Programme/Training"
                                        // rows={10} // Set the number of rows to 5
                                        style={{ height: "150px", resize: "none" }} // Prevent resizing with cursor
                                        disabled={disabled || isView}
                                    />
                                    <ErrorMessage name="description" component="div" className="text-danger fs-14 fw-400 mt-1" />
                                </div>
                            </div>
                            {(!disabled && !isView) && (
                                <>
                                    <div className="border-before pt-4"></div>
                                    <div className="right-content d-flex gap-5 justify-content-end pt-5 btn_css">
                                        <PlainButton type="submit" isLoading={isSubmitting} disabled={selectedFiles?.length < 6}>
                                            Submit
                                        </PlainButton>
                                    </div>
                                </>
                            )}
                        </Form>
                    );
                }}
            </Formik>
        </>
    );
};

export default CreateCPDActivitiesForm;
